import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import secureBackendApiDomains from './secure-backend-api-domains';

const gateway = isProdVersion() ? secureBackendApiDomains.production : secureBackendApiDomains.staging;

export default gateway;
